import { Component, Input, OnInit } from "@angular/core";
import {
  NgbActiveModal,
  NgbModal,
  NgbModalOptions,
} from "@ng-bootstrap/ng-bootstrap";
import { ContactsService } from "../../pages/contacts/contacts.service";
import { AddContact } from "../../pages/contacts/contacts.model";
import { ToastrService } from "ngx-toastr";
import { CommonDropdownModel } from "../../../companies/pop-ups/add-company/add-company.model";
import { CommonTabService } from "src/app/shared/services/common-tab.service";
import { CommonModelPopUpComponent } from "src/app/shared/components/common-model-pop-up/common-model-pop-up.component";
import { Button, PopUpTitles } from "src/app/shared/model/enum";
import { TabsService } from "src/app/shared/components/tabs/tabs.service";
import { AgGridService } from "src/app/shared/components/ag-grid/ag-grid.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-add-contact",
  templateUrl: "./add-contact.component.html",
  styleUrls: ["./add-contact.component.scss"],
})
export class AddContactComponent implements OnInit {
  @Input() title: string = "Add";
  @Input() isCompany:boolean = true;
  @Input()  insertConatactModel = new AddContact();
  @Input() disabledVendor: boolean = false;
  @Input() disabledCompany: boolean = false;
  isEmailInvalid: boolean = false;
  enumButtonName = Button;
  constructor(
    public activeModal: NgbActiveModal,
    public contactsService: ContactsService,
    public toaster: ToastrService,
    public commonTabService: CommonTabService,
    private modalService: NgbModal,
    public tabService:TabsService,
    public agGridService: AgGridService,
    private router:Router
  ) {}

  // insertConatactModel = new AddContact();
  insertConatactList: AddContact[] = [];
  timezoneList: CommonDropdownModel[] = [];
  genderList: CommonDropdownModel[] = [];
  companyNameList: CommonDropdownModel[] = [];
  enumPopUpTitles = PopUpTitles;
  departmentList: CommonDropdownModel[] = [];
  vendorNameList :CommonDropdownModel[] = []
  currentTab = ''
  submited: boolean = false;
  ngOnInit(): void {
    this.agGridService.unChecked.subscribe(res=>{
      if( res == false){
        this.insertConatactModel.markAsPrimaryContact = false;
      }
    })
    this.tabService.currentTab.subscribe(res => {
      this.currentTab = res
    })
    if(!this.currentTab){
      this.currentTab = this.tabService.thisTab
    }
    this.commonTabService.getAllDropdownList.subscribe((res: any) => {
      if (res) {
        this.genderList = res.genderList;
        this.timezoneList = res.timezoneList;
        this.companyNameList = res.companyNameList;
        this.departmentList = res.departmentList;
        this.vendorNameList = res.vendorNameList;
       
      }
    });
  }

  addContact(addContact) {
    this.insertConatactModel.currentUrl = this.router.url
    if (this.insertConatactModel.firstName && this.insertConatactModel.lastName && this.insertConatactModel.companyId) {
       if(this.isEmailInvalid){
        this.submited = true
        this.toaster.error('Please enter a valid email address with the pattern: user@example.com')
      }else{
  
      //this.insertConatactModel.isDeleted = false;
      if(addContact == 'Add'){
        this.contactsService.addContactService(this.insertConatactModel) .subscribe((res) => {
          if (res.isSuccess == true) {
            this.toaster.success(res.message);
            this.activeModal.close({ isSuccess: true, response: res?.response });
          }
          else {
            if (this.currentTab == 'vendor-contact') {
              this.toaster.error('Vendor Name Required');

            } else {
              this.submited = true;
              this.toaster.error('Company Name Required');
            }
          }
        });

      }else if(addContact == 'Save'){
        this.contactsService.updateContactService(this.insertConatactModel) .subscribe((res) => {
          if (res.isSuccess == true) {
            this.toaster.success(res.message);
            const { id, firstName, lastName } = this.insertConatactModel;
            this.activeModal.close({
              isSuccess: true,
              response: res.response,
              tabUpdate: {
                id,
                title: `${firstName} ${lastName}`
              }
            });
            
          }
          else {
            if (this.currentTab == 'vendor-contact') {
              this.toaster.error('Vendor Name Required');

            } else {
              this.submited = true;
              this.toaster.error('Company Name Required');
            }
          }
        });

      }
     }
    }  else {
      this.submited = true;
      this.toaster.error('Fill Required Fields');
    }

  }

  openReplacePrimaryPopup(contactInfo) {
    if(this.insertConatactModel.firstName && this.insertConatactModel.lastName  && this.insertConatactModel.companyId){
    const modalOption: NgbModalOptions = {
      centered: false,
      backdrop: "static",
      keyboard: false,
      windowClass: "markAsActiveInactive",
    };
    const modalRef = this.modalService.open(
      CommonModelPopUpComponent,
      modalOption
    );
    modalRef.componentInstance.title =
      this.enumPopUpTitles.REPLACE_PRIMARY_CONTACT;
    modalRef.result.then((result) => {
      if (result.confirm) {
        this.insertConatactList.map((x) => (x.markAsPrimaryContact = false));
        contactInfo.isPrimary = result.confirm;
      } else {
        contactInfo.isPrimary = result.confirm;
      }
    });
  }else{
    setTimeout(() => {
      this.insertConatactModel.markAsPrimaryContact = false;      
    }, 100);
    this.toaster.error("Fill All Required Fields")
  }
  }

}
